import React from 'react';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';
import dialogStyles from './styles/dialog';
import contentWrapperStyles from './styles/contentWrapper';
import contentStyles from './styles/content';
import headerStyles from './styles/header';
import titleStyles from './styles/title';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';

const styles = (theme) => {
  const common = {
    body: {
      ...bodyStyles(theme),
      minHeight: undefined,
    },
    content: {
      ...contentStyles(theme),
      textAlign: 'center',
      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        borderLeft: '4px solid #00dfeb',
      },
    },
    contentWrapper: {
      ...contentWrapperStyles(theme),
      paddingBottom: 0,
    },
    dialog: {
      ...dialogStyles(theme),
      maxWidth: 500,
      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        height: undefined,
        maxWidth: '90%',
      },
    },
    footer: {
      ...footerStyles(theme),
      boxShadow: 'none',
    },
    header: headerStyles(theme),
    title: titleStyles(theme),
  };
  return common;
};

const Warning = ({ classes, close, commonClasses, message, title }) => (
  <div className={classnames('dialog-warning', commonClasses, classes.dialog)}>
    <form className={classnames('modal-content', classes.content)}>
      <div className={classnames('modal-header', classes.header)}>
        <h4 className={classnames('modal-title', classes.title)} id="modal-title">
          {title}
        </h4>
      </div>
      <div className={classnames('modal-body', classes.body)} id="modal-body">
        <div className={classnames('modal-content-wrapper', classes.contentWrapper)}>
          <p>{message}</p>
        </div>
      </div>
      <div className={classnames('modal-footer', classes.footer)}>
        <Button className="btn btn-primary popbox-btn0" data-key="0" onClick={close}>
          OK
        </Button>
      </div>
    </form>
  </div>
);

Warning.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = ({ dialogs }) => ({
  message: dialogs.params.message,
  title: dialogs.params.title,
});

const WarningStyled = withStyles(styles)(Warning);

export default connect(mapStateToProps, { close: dialogActions.close })(WarningStyled);
